/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetJobsResponseData,
  GetJobsResponseDataFromJSON,
  GetJobsResponseDataFromJSONTyped,
  GetJobsResponseDataToJSON
} from './GetJobsResponseData'

/**
 *
 * @export
 * @interface GetJobsResponse
 */
export interface GetJobsResponse {
  /**
   *
   * @type {number}
   * @memberof GetJobsResponse
   */
  status?: number
  /**
   *
   * @type {GetJobsResponseData}
   * @memberof GetJobsResponse
   */
  data?: GetJobsResponseData
}

export function GetJobsResponseFromJSON(json: any): GetJobsResponse {
  return GetJobsResponseFromJSONTyped(json, false)
}

export function GetJobsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJobsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetJobsResponseDataFromJSON(json['data'])
  }
}

export function GetJobsResponseToJSON(value?: GetJobsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetJobsResponseDataToJSON(value.data)
  }
}
